export const groupHeaderConstants = {
    headerProps:
    {
        contactID: {title: 'ContactID', hidden: true},
        contactEmail: {title: 'Contact Email'},
        firstName: { title: 'First Name' },
        lastName: { title: 'Last Name' },
        contactType: {title: 'Contact Type'},
        rec2: { title: 'Rec 2.0',type: 'custom' },
        ltcMetricEssentials: { title: 'LTC Metric Essentials',type: 'custom'},
        ltcMetricElite: { title: 'LTC Metric Elite',type: 'custom'},
        retailMetricEssentials: { title: 'Retail Metric Essentials',type: 'custom'},
        retailMetricElite: { title: 'Retail Metric Elite',type: 'custom'},
    }
}

export const rpidHeaderConstants = {
    headerProps:
    {
        contactID: {title: 'ContactID', hidden: true},
        contactEmail: {title: 'Contact Email'},
        firstName: { title: 'First Name' },
        lastName: { title: 'Last Name' },
        contactType: {title: 'Contact Type'},
        rec2: { title: 'Rec 2.0',type: 'custom' },
        ltcMetricEssentials: { title: 'LTC Metric Essentials',type: 'custom'},
        retailMetricEssentials: { title: 'Retail Metric Essentials',type: 'custom'},
    }
}